function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.23346 0.529297C2.19084 0.529297 0.529297 2.19084 0.529297 4.23346C0.529297 6.27608 2.19084 7.93762 4.23346 7.93762C6.27608 7.93762 7.93763 6.27608 7.93763 4.23346C7.93763 2.19084 6.27608 0.529297 4.23346 0.529297ZM4.23346 1.8522C4.96096 1.8522 5.55638 2.44765 5.55638 3.17514C5.55638 3.90263 4.96096 4.49805 4.23346 4.49805C3.50597 4.49805 2.91055 3.90263 2.91055 3.17514C2.91055 2.44765 3.50597 1.8522 4.23346 1.8522ZM3.17513 5.02722H5.2918C6.01418 5.02722 6.6041 5.61236 6.61368 6.33255C6.03238 6.9915 5.18357 7.40845 4.23346 7.40845C3.28336 7.40845 2.43454 6.9915 1.85325 6.33255C1.86283 5.61236 2.45274 5.02722 3.17513 5.02722Z"
});

var SvgAvatar = function SvgAvatar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 8 8",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAvatar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/avatar.af69c704.svg";
export { ForwardRef as ReactComponent };